"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const calculateActiveDestructibles = () => {
    const max = 2;
    const activeDestructibles = state_1.default.activeDestructibleIDs;
    const diff = max - activeDestructibles.length;
    const destructibles = (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getUnbrokenDestructibles().filter((unbrokenDestructible) => activeDestructibles.includes(unbrokenDestructible) === false);
    for (let i = 0; i < diff; i++) {
        if (destructibles.length > 0) {
            const index = Math.floor(Math.random() * destructibles.length);
            const destructible = destructibles[index];
            activeDestructibles.push(destructible);
            destructibles.splice(index, 1);
        }
    }
    state_1.default.activeDestructibleIDs = activeDestructibles;
};
exports.default = calculateActiveDestructibles;
